import React from 'react';
import OpinionList from '../components/OpinionList';
import { Helmet } from 'react-helmet-async';

const Opinions = () => {
  return (
    <div className="container mx-auto px-4 py-8 max-w-6xl">
      <Helmet>
        <title>Threats to Democracy: Opinions | Cult of the Red Hat</title>
        <meta name="description" content="Read analysis and perspective on current events and political developments." />
        <link rel="canonical" href={`${window.location.origin}/o/`} />
        <meta property="og:title" content="Threats to Democracy: Opinions | Cult of the Red Hat" />
        <meta property="og:description" content="Read analysis and perspective on current events and political developments." />
        <meta property="og:url" content={`${window.location.origin}/o/`} />
        <meta property="og:type" content="website" />
      </Helmet>
      
      <div className="mb-8 text-center">
        <h1 className="text-3xl font-bold mb-2">Threats to Democracy: Opinions</h1>
        <p className="text-gray-600 max-w-3xl mx-auto">
          Analysis and perspective on current events and political developments.
        </p>
      </div>
      
      <OpinionList />
    </div>
  );
};

export default Opinions;